import { routes as authRoutes } from "../lib/modules/auth/auth-routes.js";
import { routes as accountRoutes } from "../lib/modules/account/account-routes.js";
import { routes as errorRoutes } from "../lib/pages/error-page-routes.js";
import { createClassModuleFactory } from "../lib/ui/factories/module-factory-helpers.js";

const fileRepositoryModuleLoader = () => import('./modules/core/FileRepositoryBrowser.js');
const fileRepositoryModuleFactory = createClassModuleFactory(fileRepositoryModuleLoader, 'FileRepositoryBrowser');

const testPageLoader = () => import('./modules/test/TestPage.js');
const testCssTypographyLoader = () => import('./modules/test/TestCssTypography.js');
const testCssGridLoader = () => import('./modules/test/TestCssGrid.js');
const testCssInputsLoader = () => import('./modules/test/TestCssInputs.js');
const testCssHelpersLoader = () => import('./modules/test/TestCssHelpers.js');
const testControlsLoader = () => import('./modules/test/TestControls.js');

const testPageFactory = createClassModuleFactory(testPageLoader, 'TestPage');
const testCssTypographyFactory = createClassModuleFactory(testCssTypographyLoader, 'TestCssTypography');
const testCssGridFactory = createClassModuleFactory(testCssGridLoader, 'TestCssGrid');
const testCssInputsFactory = createClassModuleFactory(testCssInputsLoader, 'TestCssInputs');
const testCssHelpersFactory = createClassModuleFactory(testCssHelpersLoader, 'TestCssHelpers');
const testControlsFactory = createClassModuleFactory(testControlsLoader, 'TestControls');

const workspaceBrowserLoader = () => import('./modules/projects/WorkspaceBrowser.js');
const workspaceBrowserFactory = createClassModuleFactory(workspaceBrowserLoader, 'WorkspaceBrowser');

const projectEditorLoader = () => import('./modules/projects/ProjectEditor.js');
const projectEditorFactory = createClassModuleFactory(projectEditorLoader, 'ProjectEditor');

const modelSectionEditorLoader = () => import('./modules/projects/ModelSectionEditor.js');
const modelSectionEditorFactory = createClassModuleFactory(modelSectionEditorLoader, 'ModelSectionEditor');


export const defaultRoutes = {
    defaultRouteName: 'workspace-home',
    loginRouteName: 'auth-login',
    notFoundRouteName: 'error-not-found',
    unauthorizedRouteName: 'error-unauthorized',
    forbiddenRouteName: 'error-forbidden',
};

export const routes = [

    ...authRoutes,
    ...accountRoutes,
    ...errorRoutes,

    // -------------------------------------------------------------- public

    // -------------------------------------------------------------- protected

    // Workspace

    { name: 'workspace-home', path: '/workspace', factory: workspaceBrowserFactory, default: true, privileges: ['adminProjects', 'manageProjects', 'editProjects', 'readProjects'] },
    { name: 'workspace-browser', path: '/workspace/:workspaceUid', factory: workspaceBrowserFactory, privileges: ['adminProjects', 'manageProjects', 'editProjects', 'readProjects'] },
    { name: 'workspace-project-editor', path: '/workspace/:workspaceUid/projects/:projectUid', factory: projectEditorFactory, privileges: ['adminProjects', 'manageProjects', 'editProjects', 'readProjects'] },
    { name: 'workspace-project-model-section-editor', path: '/workspace/:workspaceUid/projects/:projectUid/model-sections/:modelSectionUid', factory: modelSectionEditorFactory, privileges: ['adminProjects', 'manageProjects', 'editProjects', 'readProjects'] },

    // File Repository

    { name: 'file-repository-folder', path: '/file-repository/folder/:uid', factory: fileRepositoryModuleFactory, privileges: ['useFileRepository', 'adminFileRepository'] },
    { name: 'file-repository', path: '/file-repository', factory: fileRepositoryModuleFactory, privileges: ['useFileRepository', 'adminFileRepository'] },

    // Test

    { name: 'test-page', path: '/test-page', factory: testPageFactory },
    { name: 'test-css-typography', path: '/test-css-typography', factory: testCssTypographyFactory },
    { name: 'test-css-grid', path: '/test-css-grid', factory: testCssGridFactory },
    { name: 'test-css-inputs', path: '/test-css-inputs', factory: testCssInputsFactory },
    { name: 'test-css-helpers', path: '/test-css-helpers', factory: testCssHelpersFactory },
    { name: 'test-controls', path: '/test-controls', factory: testControlsFactory },

];
